export const ZacetneStevilkeUmtsEnum = [
  '064',
  '031',
  '041',
  '051',
  '071',
  '040',
  '030',
  '070',
  '068',
  '069'
]



// WEBPACK FOOTER //
// ./src/assets/js/Enum/ZacetneStevilkeUmtsEnum.js